// Special value of Project ID used by QCS to identify "Client only" transactions (i.e. ID that Web or Mobile can pass to QCS API to get all transactions that are not assigned to any projects)
export const QCS_ID_FOR_CLIENT_ONLY_UI_OPTION = '0';
// Delimiter Used to identify customerId belonging to selected "Client only" UI option
export const VALUE_DELIMITER_FOR_CLIENT_ONLY_UI_OPTION = ':';
// Display Name for "Client only" UI option
export const DISPLAY_NAME_FOR_CLIENT_ONLY_UI_OPTION = 'No project';
// Resource Type value for Clients and Projects filter
export const CLIENTS_AND_PROJECTS_FILTER_RESOURCE_TYPE = 'clientsAndProjects';
